import React from "react";

import { restaurantService } from "../../jwt/_services/ayb/restaurantService";

export const restaurantProvider = {
    getOptions
}

async function getOptions(customFilter) {
    try {
        const listItems = await restaurantService.getOptions( customFilter );
        const {data:{ options, info }} = listItems

         let data = options.map( (item) => ({
            id: item.id,
            value: item.code,
            label: <label>{ item.title }</label>
        }) );

        return [data, info]
    } catch (error) {
        console.log(error.message)
    }
}